import './index.css';
import './i18n';

import App from './App';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { store } from './Observodon/store/store';

const Component = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

// ReactDOM.render(<Component />, document.getElementById('app'));
const root = createRoot(document.getElementById('app') as HTMLElement);
root.render(<Component />);
